var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreroll = function SvgPreroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#preroll_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12.139 29.592 34.656 6.811c.606.102.915 1.266.69 2.6s-.9 2.332-1.507 2.23l-35.05-4.485c-.864-.145-1.342-1.683-1.86-2.726-.519-1.044-1.413-.89-1.312-1.487s.895-.16 1.728-.976c.833-.817 1.79-2.113 2.655-1.967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m39.135 34.898-1.05 5.325 7.893 1.01c.606.102 1.281-.896 1.506-2.23s-.083-2.498-.689-2.6zM7.78 32.778l.095-.48a.4.4 0 0 0-.12.237.4.4 0 0 0 .025.243",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m39.135 34.898.145-.736a.75.75 0 0 0-.881.59zm-1.05 5.325-.736-.145a.75.75 0 0 0 .64.889zm7.893 1.01.124-.74-.028-.004zm1.506-2.23-.74-.125zm-.689-2.6-.145.736.02.004zM7.781 32.778l-.678.32a.75.75 0 0 0 1.414-.175zm.095-.48.736.145a.75.75 0 0 0-1.236-.704zm-.12.237-.74-.125zm30.643 2.218-1.05 5.325 1.471.29 1.05-5.325zm7.675 5.736-7.894-1.01-.19 1.488 7.893 1.01zm.67-1.611c-.098.586-.291 1.062-.491 1.359-.242.357-.315.229-.15.257l-.249 1.479c.771.13 1.338-.447 1.642-.897.345-.51.602-1.2.728-1.948zm-.073-1.735c-.166-.028-.055-.127.056.29.091.345.117.858.018 1.445l1.479.25c.126-.748.11-1.483-.047-2.08-.14-.523-.486-1.255-1.258-1.385zm-7.68-1.51 7.66 1.506.289-1.472-7.66-1.505zm-30.474-2.71.095-.48-1.472-.29-.095.48zm-.022-.263a.3.3 0 0 1-.029.08.4.4 0 0 1-.09.116l-1-1.117a1.14 1.14 0 0 0-.36.67zm-.036-.202a.4.4 0 0 1 .037.128c.004.04 0 .066 0 .074l-1.48-.25c-.037.221-.021.46.087.689z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M37.245 34.526c.694.117 1.26 1.402 1.002 2.93s-1.03 2.673-1.726 2.556M4.622 6.118c1.434 1.525 2.964 5.236.734 13.392s.735 10.242.735 10.242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "preroll_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })))));
};
export default SvgPreroll;